import styles from './InstagramEmbed.module.scss';

const InstagramEmbed = ({ html }: { html: string }) => (
  <div
    data-testid="data-instagram-media-embed"
    className={styles.instagramContainer}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);
export default InstagramEmbed;
